/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { loadQuery, type PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import BACKLOG_FILTER_REFINEMENT_QUERY from '@jira/software__backlog-header/src/controls-bar/backlog-filter-refinement/__generated__/BacklogFilterRefinementQuery$parameters.ts';
import type { BacklogFilterRefinementQuery } from '@jira/software__backlog-header/src/controls-bar/backlog-filter-refinement/__generated__/BacklogFilterRefinementQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createAri } from '@jira/platform__utils-ari/src/index.tsx';

import { createResource, type RouteResource } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';

import { RESOURCE_TYPE_NEXTGEN_BACKLOG_FILTER_REFINEMENT } from './resourceTypeNextgenBacklog.constants.tsx';

export const backlogFilterRefinementResource: RouteResource<
	PreloadedQuery<BacklogFilterRefinementQuery, Record<string, unknown>>
> = createResource<PreloadedQuery<BacklogFilterRefinementQuery>>({
	type: RESOURCE_TYPE_NEXTGEN_BACKLOG_FILTER_REFINEMENT,
	getKey: () => 'backlog-filter-refinement-relay',
	getData: async ({ match, query }, { tenantContext }) => {
		const variables = {
			cloudId: tenantContext.cloudId,
			jql: query.jql ?? '',
			boardId: createAri({
				resourceOwner: 'jira-software',
				cloudId: tenantContext.cloudId,
				resourceType: 'board',
				resourceId: String(match.params.boardId),
			}),
			filterRefinementScope: {
				backlog: {
					boardId: Number(match.params.boardId),
				},
			},
		};

		const queryReference = loadQuery<BacklogFilterRefinementQuery>(
			getRelayEnvironment(),
			BACKLOG_FILTER_REFINEMENT_QUERY,
			variables,
			{
				fetchPolicy: 'store-and-network',
			},
		);

		return queryReference;
	},
	isBrowserOnly: true,
	maxAge: 0,
});
